export { default } from "./LinkIcon";
